<template>
  <div class="container">
    <div v-show="!data.loading" class="table-responsive-md">
      <table class="table table-condensed table-striped standard-report">
        <thead>
          <tr class="table-header header text-left">
            <th>
              <span class>Discount/Comp</span>
            </th>
            <th class="text-center">
              <span class>Instances</span>
            </th>
            <th class="text-right">
              <span class>Totals</span>
            </th>
            <th class="text-right">
              <span class>%</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-right" v-for="(d, dindex) in data.salesSummary.results" :key="dindex">
            <td class="text-left">
              <sales-check-list-modal
                v-bind:locationId="[locationId]"
                v-bind:startDate="d.checkdate"
                v-bind:promoId="d.promo_id"
              >
                {{d.promoNAME}}
                <span v-show="d.includedinsales">(included with sales)</span>
              </sales-check-list-modal>
            </td>
            <td class="text-center">{{d.pcount}}</td>
            <td class="text-right">{{d.ptotal | currency}}</td>
            <td class="text-right">{{d.pct | number('0.0')}}%</td>
          </tr>
          <tr class="border-right" v-show="!data.salesSummary.results.length > 0">
            <td class="text-center" colspan="4">NO DATA AVAILABLE</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="border-right">
            <td class="label-total">
              <strong>Totals:</strong>
            </td>
            <td
              class="cell-running-total"
              style="color:green; text-align: center;"
            >{{data.salesSummary.pcount}}</td>
            <td class="cell-running-total text-right">{{data.salesSummary.ptotal | currency}}</td>
            <td class="cell-running-total text-right">{{data.salesSummary.pct | number('0.0')}}%</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import salesCheckListModal from '@/components/modals/sales/salesCheckListModal'
import DailyJournalReportService from '@/services/DailyJournalReportService'
import dailyReportTab from './dailyReportTab'

export default {
  extends: dailyReportTab,
  components: {
    salesCheckListModal
  },
  data () {
    return {
      data: {
        loading: true,
        salesSummary: {
          results: [],
          shifts: []
        }
      },
      loadTimeout: null
    }
  },
  props: {
    locationId: {
      default () {
        return 0
      }
    },
    dailyDate: {
      type: Date,
      default () {
        return new Date()
      }
    },
    isActive: {
      default () {
        return 0
      }
    }
  },
  watch: {
    locationId: function (n, o) {
      if (n !== o) {
        this.loadData()
      }
    },
    dailyDate: function (n, o) {
      if (n !== o) {
        this.loadData()
      }
    },
    isActive: function (n, o) {
      if (n !== o) {
        this.loadData()
      }
    }
  },
  computed: {
    grossView: function () {
      return UserService.getConfigOption('gross_sales_view').value === 'yes'
    },
    checkGuestStats: function () {
      return UserService.getConfigOption('avg_check_guest_stats').value === 'yes'
    }
  },
  methods: {
    loadData: function () {
      if (this.isActive > 0 && this.loadTimeout === null) {
        this.loadTimeout = setTimeout(() => {
          this.$updateloading(1)
          this.data.loading = true
          DailyJournalReportService.getDiscountSummary(this.locationId, this.dailyDate, (this.grossView ? 'gross' : 'net'))
            .then(res => {
              this.$updateloading(-1)
              this.data.loading = false
              this.data.salesSummary = res
              this.loadTimeout = null
            })
        }, 100)
      }
    }
  }
}
</script>
